export default {
  computed: {
    mess() {
      return this.$store.getters.mess || {};
    }
  }
};
